<template>
  <v-dialog v-model="dialog" width="400">
    <v-card flat>
      <v-toolbar flat fluid>
        <v-toolbar-title>Thêm Contacts</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container>
        <contact-form ref="newContactForm"></contact-form>
      </v-container>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn depressed small color="error" @click="cancel">Cancel</v-btn>
        <v-btn depressed small color="success" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ContactForm from '@/components/basic/form/ContactForm'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  components: {
    ContactForm
  },
  props: {
    state: Boolean,
    student: Object
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapState('app', ['roles', 'department', 'staff']),
    ...mapState('course', ['course']),
    ...mapState('session', ['session']),
    ...mapState('contact', ['contact']),
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('contact', ['createContact']),
    async save () {
      const data = this.$refs.newContactForm.getData()
      await this.createContact({
        onboard: moment().toISOString(),
        provider: 'SC3',
        staff: this.staff.id,
        student: this.student ? this.student.id : '',
        ...data
      })
      this.dialog = false
    },
    cancel () {
      this.$refs.newContactForm.reset()
      this.dialog = false
    }
  },
  watch: {
    state (state) {
      this.dialog = true
    }
  }
}
</script>
